import { cn } from '@costar-ui/cosmos'
import React, { useCallback, useMemo } from 'react'

import Row from './primitives/row'
import TableCell from './table-cell'
import type { TableRowProps } from './types'

function TableRow<TData>(props: TableRowProps<TData>) {
  const { row, cellProps, index, onRow, style, className, ...rest } = props
  const additionalProps = onRow?.(row.original, index)
  const rowStyles = useMemo(
    () => ({ ...style, ...(additionalProps ? additionalProps.style : null) }),
    [additionalProps, style]
  )
  const rowClassNames = cn(className, additionalProps?.className)
  const rowOnClick = useCallback(
    (event: React.MouseEvent<HTMLTableRowElement>) => {
      additionalProps?.onClick?.(event)
    },
    [additionalProps]
  )
  return (
    <Row
      {...additionalProps}
      className={rowClassNames}
      onClick={rowOnClick}
      style={rowStyles}
      {...rest}
    >
      {row.getVisibleCells().map(cell => (
        <TableCell key={cell.id} cell={cell} {...cellProps} />
      ))}
    </Row>
  )
}

export default TableRow
